const filterData = [
  // Tags filter temporarily hidden. Uncomment when tags filtering is needed again.
  // {
  //   key: "tags",
  //   title: "Tags",
  //   type: "search checkbox",
  // },
  // { key: "vendorCategory", title: "Vendor Category", type: "search taxonomy" },
  // {
  //   key: "category",
  //   title: "Category",
  //   type: "checkboxes",
  //   options: [
  //   "Contractor (Providing and Fixing)",
  //   "Labour Contractor",
  //   "Material Supplier",
  //   "Consultant",
  //   "Others"
  //   ],
  // },
  {
    key: "financialYear",
    title: "Financial Year",
    type: "dynamic financial year",
  },
  {
    key: "vendorInvitationCount",
    title: "Vendor Invitation Count",
    type: "radio",
  },
  {
    key: "vendorActivity",
    title: "Vendor Activity",
    type: "radio",
    options: ["All Vendors", "With Orders", "Without Orders"],
  },
  {
    key: "totalOrderValue",
    title: "Total Order Value",
    type: "amount range",
  },
  {
    key: "gstPanAvailability",
    title: "GSTIN and PAN Number",
    type: "gst pan availability radio",
    options: [
      { label: "All", value: "all" },
      { label: "With GSTIN or PAN", value: "with" },
      { label: "Without GSTIN or PAN", value: "without" },
    ],
  },
  { key: "location", title: "City & Area", type: "search radio" },
  {
    key: "addedBy",
    title: "Created By",
    type: "search checkbox",
  },
  {
    key: "createdDate",
    title: "Created Date",
    type: "dateFilter",
  },
];

export default filterData;
